import React from 'react';

export default function ReadonlyLink(props) {
    return <span className="readonly-link">{props.children}</span>
}